import axios from "axios";
import { CORREO_USUARIO } from "config/general/Configuracion";
import { API_CONFIGURACION } from "config/general/Configuracion";
import { ID_CUENTA } from "config/general/Configuracion";
import { HEADERS, apiTimeout } from "config/general/Configuracion";


const RegistroDispositivosApiHelper = {

    listarDispositivosRegistrados: async () => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/listar_dispositivos_registrados/${sessionStorage[ID_CUENTA]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al listar dispositivo registrado:", error);
            throw error;
        }
    },

    actualizarDispositivosRegistrados: async (dispositivo) => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/actualizar_dispositivo_registrado/${sessionStorage[ID_CUENTA]}`;
            const response = await axios.put(url, dispositivo, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al actualizar dispositivo registrado:", error);
            throw error;
        }
    },

};

export default RegistroDispositivosApiHelper;
